import { useState } from "react";
import styles from "../NewsletterModal.module.scss";

const TimeSelector = () => {
  const [time, setTime] = useState({
    fromDays: 0,
    fromHours: 1,
    fromMinutes: 0,
    toDays: 0,
    toHours: 1,
    toMinutes: 0,
  });

  const handleChange = (field, value) => {
    setTime((prev) => ({
      ...prev,
      [field]: Math.max(0, value),
    }));
  };

  const renderTimeSelector = (label, field) => (
    <div className={styles.datePickerFromItem}>
      <h4 className={styles.datePickerTitle}>{label}</h4>
      <p>{time[field]}</p>
      <div className={styles.itemButtonContainer}>
        <button
          className={styles.itemButton}
          onClick={() => handleChange(field, time[field] - 1)}
        >
          -
        </button>
        <button
          className={styles.itemButton}
          onClick={() => handleChange(field, time[field] + 1)}
        >
          +
        </button>
      </div>
    </div>
  );

  return (
    <div className={styles.datePickerContainer}>
      <div className={styles.dataPicker}>
        <label>От</label>
        <div className={styles.dataPickerButtons}>
          {renderTimeSelector("Дней", "fromDays")}
          {renderTimeSelector("Часов", "fromHours")}
          {renderTimeSelector("Минут", "fromMinutes")}
        </div>
      </div>
      <div className={styles.dataPicker}>
        <label>До</label>
        <div className={styles.dataPickerButtons}>
          {renderTimeSelector("Дней", "toDays")}
          {renderTimeSelector("Часов", "toHours")}
          {renderTimeSelector("Минут", "toMinutes")}
        </div>
      </div>
    </div>
  );
};

export default TimeSelector;
